var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRectangleSelected = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 36 32"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 20,
  x: 1,
  y: 6,
  stroke: "#000",
  strokeWidth: 2,
  rx: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 2,
  d: "M3 8h30v16H3z"
})));
export { SvgRectangleSelected as ReactComponent };